import { BrandMark } from "@/components/brand";
import { Spinner } from "@/components/ui/surface";

/**
 * Shown on first load while the page's code arrives. Without it the router
 * renders nothing, which on a slow phone connection looks like a broken app.
 */
export function AppLoading() {
  return (
    <div className="grid min-h-dvh place-items-center bg-background">
      <div className="flex flex-col items-center">
        <BrandMark className="size-12" />
        <Spinner label="Loading GridAction" />
      </div>
    </div>
  );
}
